<template>
    <div id="edit">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-user-circle"></i> Students</div>
        </div>
        <hr>
        <form class="box">
            <div class="columns is-multiline">
                <div class="column is-6">
                    <div class="field">
                        <bulma-input name="provider_id" v-model="student.provider_id" rules="required" placeholder='Provider id'/>
                    </div>
                </div>

                <div class="column is-6">
                    <div class="field">
                        <bulma-input name="name" v-model="student.name" rules="required" placeholder='Name'/>
                    </div>
                </div>

                <div class="column is-6">
                    <div class="field">
                        <bulma-input name="name" v-model="student.nick" rules="" placeholder='Nick'/>
                    </div>
                </div>

                <div class="column is-6">
                    <div class="field">
                        <div class="select is-fullwidth">
                            <select v-model="student.gender">
                                <option value="male">male</option>
                                <option value="female">female</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="column is-6" v-if="schools && schools.length > 0">
                    <div class="field">
                        <div class="select is-fullwidth">
                            <select v-model="student.school_id">
                                <option v-bind:value="school.id" v-for="school in schools">{{school.name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-multiline"> 
                <div class="column is-2">                    
                    <loading-button v-bind:loading="loading" color="is-info" @click="save()">Save</loading-button>                    
                </div>              
                <div class="column is-2 is-offset-8 is-pulled-right">                                           
                    <a href="javascript:history.go(-1)" class="button is-block">
                        Back
                    </a>                   
                </div>              
            </div>                      
        </form>
    </div>  
</template>

<script>
import StudentRepo from '../../repos/StudentRepo'
import SchoolRepo from '../../repos/SchoolRepo'
import _ from 'lodash'

export default {
  name: 'students-edit',
  components: {},
  data() {
        return {
            repo: new StudentRepo(this.$auth),
            schoolRepo: new SchoolRepo(this.$auth),
            loading: false,
            schools: [],
            student: {},
        }
  },
  created(){  
    this.getSchools();
    this.getStudent(this.$route.params.id);
  },
  methods: {
    getStudent(id){
        this.repo.show(id).then(response => { 
            this.student = response.data.data;
            if(this.student.school){
                this.student.school_id = this.student.school.id;
            }
        });         
    },
    getSchools(){
          this.schoolRepo.all().then(response => {
              this.schools = response.data.data;

          });
    },
    save(){            
        this.$validator.validateAll().then((result) => {
	    if (result) {
                let self = this;
                this.loading = true;                                
                
                this.repo.update(this.student.id, this.student).then(function (response) {
                    
                    self.loading = false;
                    self.$toast.success(response.data.message);
                    self.$router.push('/dashboard/students');
                }).catch(function(response){
                    self.loading = false;                    
                    return Promise.reject(response);
                });
            }
        });
    
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/students/Edit.vue